import { useStores } from "@client/store";
import { Flex, useTheme } from "@ugc-ui/lego";
import { observer } from "mobx-react-lite";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Path } from "@common/consts/Path";
import { ConfirmActionModalType } from "@common/components/Modal/ConfirmActionModal/ConfirmActionModal.utils";
import { useIsMobile } from "@common/hooks/isMobile";
import {
  campaignViewPagePatternRegExp,
  editPagePatternRegExp,
} from "@common/typings/common";
import {
  CreateCompainButton,
  HeaderContainer,
  HeaderLogo,
  HeaderTitle,
  LinkStyled,
} from "./Header.styled";
import { ProfileMenu } from "./ProfileAvatarMenu/ProfileMenu";

export const Header = observer(() => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  const {
    client: {
      authStore: { user },
    },
    exitModalStore,
  } = useStores();

  const isOnCreateCampaignPage = location.pathname === Path.TO_CREATE;
  const isOnEditCampaignPage = editPagePatternRegExp.test(location.pathname);
  const isOnCampaignPage = campaignViewPagePatternRegExp.test(
    location.pathname
  );

  const handleClickOnLogo = () => {
    if (isOnCreateCampaignPage) {
      exitModalStore.openDialogAndAttach({
        type: ConfirmActionModalType.EXIT,
        applyCallback: () => {
          navigate(Path.TO_HOME);
        },
      });
    } else {
      window.location.replace(Path.TO_HOME);
    }
  };

  return (
    <HeaderContainer alignItems="center" justifyContent="space-between">
      <Flex alignItems="center">
        <LinkStyled onClick={handleClickOnLogo}>
          <HeaderLogo />
        </LinkStyled>

        {!isMobile &&
          (!isOnCreateCampaignPage ||
            !isOnEditCampaignPage ||
            !isOnCampaignPage) && (
            <HeaderTitle type="h6" color={theme.gray.a80}>
              Рекламный кабинет
            </HeaderTitle>
          )}
      </Flex>

      <Flex alignItems="center">
        <CreateCompainButton
          startIcon="plus"
          disabled={isOnCreateCampaignPage || isOnEditCampaignPage}
          onClick={() => {
            navigate(Path.TO_CREATE);
          }}
          dataCy="кнопка-создание-рекламной-кампании"
        >
          Создать кампанию
        </CreateCompainButton>

        <ProfileMenu avatar={user?.avatar} />
      </Flex>
    </HeaderContainer>
  );
});
